module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Metzerlen-Mariastein-cde0b17927595080e53384501e364560.svg";